import SvgIcon, { SvgIconProps } from '../../SvgIcon'

export function IdealIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 295 295" {...props}>
      <defs>
        <style>
          {`
            .cls-1 {
              fill: url(#linear-gradient);
            }
            .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {
              stroke-width: 0px;
            }
            .cls-2, .cls-3 {
              fill-rule: evenodd;
            }
            .cls-2, .cls-6 {
              fill: #232323;
            }
            .cls-3, .cls-8 {
              fill: #fff;
            }
            .cls-4 {
              fill: url(#linear-gradient-2);
            }
            .cls-5 {
              fill: #1d1c1c;
            }
            .cls-7 {
              fill: #c06;
            }
            .cls-9 {
              fill: #fff48d;
            }
          `}
        </style>
        <linearGradient
          id="linear-gradient"
          x1="152.7"
          y1="50.16"
          x2="130.19"
          y2="22.59"
          gradientTransform="translate(0 296) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".02" stopColor="#1d1c1c" stopOpacity="0" />
          <stop offset=".68" stopColor="#1d1c1c" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="113.43"
          y1="44.31"
          x2="136.51"
          y2="67.12"
          gradientTransform="translate(0 296) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".02" stopColor="#1d1c1c" stopOpacity="0" />
          <stop offset=".68" stopColor="#1d1c1c" />
        </linearGradient>
      </defs>
      <rect className="cls-9" width="295" height="295" rx="13" ry="13" />
      <g>
        <path
          className="cls-8"
          d="M56.51,22.87v136.4c0,6.53,5.37,11.87,11.93,11.87h81.89c61.91,0,88.74-34.49,88.74-80.25S212.23,11,150.32,11h-81.89c-6.56,0-11.93,5.34-11.93,11.87Z"
        />
        <path
          className="cls-7"
          d="M111.32,44.48v100.79h44.07c40.02,0,57.37-22.5,57.37-54.31s-17.36-54.07-57.37-54.07h-36.44c-4.23,0-7.63,3.44-7.63,7.6Z"
        />
        <path
          className="cls-2"
          d="M79.11,160.28h71.21c50.04,0,77.65-24.63,77.65-69.33,0-25.76-10.08-69.03-77.65-69.03h-71.21c-6.32,0-11.45,5.1-11.45,11.4v115.57c0,6.29,5.13,11.4,11.45,11.4ZM71.47,33.32c0-4.21,3.4-7.6,7.63-7.6h71.21c27.55,0,73.83,8.49,73.83,65.23,0,42.26-26.24,65.53-73.83,65.53h-71.21c-4.23,0-7.63-3.38-7.63-7.6V33.32Z"
        />
        <path
          className="cls-3"
          d="M133.01,76.3c-1.34-.48-2.74-.72-4.26-.72v-.06h-10.09v24.34h10.21c1.81,0,3.38-.36,4.72-.96,1.34-.66,2.45-1.5,3.33-2.58.88-1.08,1.52-2.4,1.98-3.9.41-1.5.64-3.12.64-4.92,0-2.04-.29-3.78-.82-5.28-.58-1.44-1.34-2.7-2.27-3.72-.99-.96-2.1-1.74-3.44-2.22ZM130.61,95.07c-.76.24-1.46.36-2.22.36v.06h-4.61v-15.35h3.73c1.28,0,2.33.18,3.21.54.88.36,1.57.96,2.1,1.62.53.66.93,1.56,1.17,2.52.23.96.35,2.1.35,3.3,0,1.38-.18,2.46-.52,3.42-.35.96-.82,1.68-1.34,2.28-.53.6-1.17,1.02-1.87,1.26Z"
        />
        <path
          className="cls-8"
          d="M160.6,75.59v4.5h-12.49v5.22h11.49v4.14h-11.49v5.94h12.78v4.5h-17.97v-24.34h17.68v.06Z"
        />
        <path
          className="cls-3"
          d="M187.32,99.93l-8.87-24.34h-5.43l-8.93,24.34h5.25l1.87-5.4h8.87l1.81,5.4h5.43ZM175.77,81.58l2.98,8.93h-6.13l3.09-8.93h.06Z"
        />
        <path className="cls-8" d="M195.78,75.58v19.85h11.55v4.5h-16.74v-24.34h5.19Z" />
        <path
          className="cls-6"
          d="M90.84,100.29c6.32,0,11.44-5.12,11.44-11.45s-5.12-11.45-11.44-11.45-11.44,5.12-11.44,11.45,5.12,11.45,11.44,11.45Z"
        />
        <path
          className="cls-6"
          d="M97.65,146.08c-8.86,0-15.96-7.65-15.96-17.05v-13.31c0-4.7,3.55-8.56,8.01-8.56s8.01,3.8,8.01,8.56v30.36h-.06Z"
        />
      </g>
      <path className="cls-5" d="M258,199H38c-1.1,0-2-.9-2-2s.9-2,2-2h220c1.1,0,2,.9,2,2s-.9,2-2,2Z" />
      <g>
        <path
          className="cls-5"
          d="M205.58,248.76c0-13.38,9.52-25.57,25.96-25.57s26.03,12.2,26.03,25.57-9.52,25.57-26.03,25.57c-16.44,0-25.96-12.2-25.96-25.57ZM243.12,248.76c0-6.45-4.25-12.4-11.58-12.4s-11.58,5.96-11.58,12.4,4.32,12.41,11.58,12.41,11.58-5.96,11.58-12.41Z"
        />
        <path
          className="cls-5"
          d="M195.47,258.26c5.48-3.12,8.77-9.08,8.77-15.66,0-9.77-7.06-18.09-18.02-18.09h-23.01v48.51h14.25v-12.4h2.67l8.15,12.4h16.78l-9.59-14.76ZM183.35,249.46h-5.89v-13.72h5.96c3.84,0,6.3,3.12,6.3,6.86s-2.54,6.86-6.37,6.86Z"
        />
        <path
          className="cls-5"
          d="M98.17,224.46l-8.55,28.91-8.34-28.91h-11.35l-8.41,28.91-8.48-28.91h-15.04l17.23,48.42h12.38l8-26.36,7.93,26.36h12.44l17.23-48.42h-15.04Z"
        />
        <path
          className="cls-5"
          d="M134.77,261.05h-.04c-5.33,0-9.07-3.22-10.67-7.48h36.21c.29-1.6.44-3.24.44-4.9,0-13.34-9.49-25.51-25.95-25.52v13.14c5.36.01,9.06,3.23,10.65,7.48h-36.16c-.29,1.6-.44,3.24-.44,4.9,0,13.35,9.5,25.53,25.91,25.53h.04v-13.15Z"
        />
        <path
          className="cls-1"
          d="M134.73,274.19c.56,0,1.1-.02,1.65-.04,3.33-.17,6.36-.85,9.06-1.94,2.7-1.1,5.07-2.6,7.08-4.42,2.01-1.82,3.68-3.95,4.97-6.3,1.17-2.13,2.03-4.45,2.57-6.86h-15.09c-.31.64-.67,1.26-1.08,1.83-.56.79-1.22,1.5-1.97,2.11-.75.62-1.59,1.14-2.51,1.54-.93.4-1.93.68-3.02.83-.53.07-1.08.11-1.65.11-3.4,0-6.14-1.31-8.1-3.36l-9.81,9.92c4.36,4.03,10.41,6.57,17.91,6.57Z"
        />
        <path
          className="cls-4"
          d="M134.73,223.14c-13.92,0-22.87,8.76-25.26,19.56h15.04c1.8-3.72,5.34-6.42,10.22-6.42,3.89,0,6.91,1.68,8.88,4.22l9.9-10.01c-4.42-4.48-10.78-7.35-18.77-7.35Z"
        />
      </g>
    </SvgIcon>
  )
}
